"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getNormalizedDay_1 = __importDefault(require("./getNormalizedDay"));
var getMonthDays = function (date, firstWeekDay) {
    var _a;
    var month = date.getMonth();
    var year = date.getFullYear();
    var weeks = [];
    var currentDate = new Date(year, month, 1);
    var firstDay = (0, getNormalizedDay_1.default)(currentDate, firstWeekDay);
    if (firstDay !== 0)
        weeks.push(new Array(firstDay).fill({}));
    while (month === currentDate.getMonth()) {
        var day = (0, getNormalizedDay_1.default)(currentDate, firstWeekDay);
        if (day === 0 || !weeks.length)
            weeks.push([]);
        weeks[weeks.length - 1].push({ date: new Date(currentDate) });
        currentDate.setDate(currentDate.getDate() + 1);
    }
    var lastDay = (0, getNormalizedDay_1.default)(currentDate, firstWeekDay);
    if (lastDay !== 0) {
        (_a = weeks[weeks.length - 1]).push.apply(_a, new Array(7 - lastDay).fill({}));
    }
    return weeks;
};
exports.default = getMonthDays;
